import React from 'react';
import { Box } from '@mui/material';

import { Typography } from '@occc/ui-design-system';

import { State } from '../redux';

type ComponentState = State['awardConfiguration']['nullAward'];
type Fields = keyof ComponentState;
export type Props = ComponentState & {
  fieldDisabled: (field: Fields) => boolean;
};
const NullAward: React.FC<Props> = () => {
  return (
    <Box>
      <Box my={4}>
        <Typography variant='subtitle1' paragraph>
          Null Award
        </Typography>
        <Typography>
          This offer will award no points. This award type is commonly used when the award is
          offered by the client upon external fulfillment, for instance in a "buy 1 get 1 free" type
          of offer.
        </Typography>
      </Box>
    </Box>
  );
};

export { NullAward };
